import React from "react";
import SideNav from "./SideNav";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  background-color: #f8f9fd;
`;

interface ILayout {
  children: React.ReactNode;
}

export default function LayoutNavigateBar(props: ILayout) {
  return (
    <Container>
      <SideNav />
      {props.children}
    </Container>
  );
}
